export enum PromoCodeUsage {
    CODE_NEEDED = 'code_needed',
    NO_CODE_NEEDED = 'no_code_needed'
}
